import { useMemo } from 'react';
import { Insights } from '../../../types/Insights';
import { TOKEN_ID_TO_DISPLAY_NAME } from '../../../consts';

const useTokenTypeToCountMap = (insights: Insights) => {
    return useMemo(() => {
        if (!insights || !insights.tokenTypeToCountMap) {
            return [];
        }

        return insights.tokenTypeToCountMap.map(({ type, count }) => {
            const progress = Math.floor((count / (insights.totalDeviceTokens || 1)) * 100);
            return {
                label: TOKEN_ID_TO_DISPLAY_NAME[type] as string,
                progress,
                tooltipContent: `${TOKEN_ID_TO_DISPLAY_NAME[type]}: ${count}`,
                startColor: '#1C89AC',
                endColor: '#C9DDE3'
            };
        });
    }, [insights]);
};

export default useTokenTypeToCountMap;
